import { PERMISSION_CONFIGS } from "permissions/configs";
import { useAppSelector } from "redux/hooks";
import AuthHelper from "components/auth/helpers";
import { Env } from "utils/Types";
import { APP_ROLES } from "utils/Constants";

const usePermission = (permission: string) => {
  let allowed = false;
  const whitelabel = useAppSelector(state => state.properties.whiteLabel);
  const { env } = useAppSelector(state => state.globalUI);

  // if whitelabel not available, nothing is allowed
  if (!whitelabel) {
    return [allowed];
  }

  // if env is International, then any EAS features should be hidden
  const permissionIsEAS = PERMISSION_CONFIGS[whitelabel][APP_ROLES.EAS]?.includes(permission);
  const isInternational = env === Env.INTERNATIONAL;
  if (permissionIsEAS && isInternational) {
    return [allowed];
  }

  const config = PERMISSION_CONFIGS[whitelabel];
  const roles = AuthHelper.getRoles();

  roles.find(r => {
    const allowedActions = config[r] || [];
    const foundAllowedAction = allowedActions.find(aa => aa === permission);
    if (foundAllowedAction) {
      allowed = true;
      return true;
    }
    return false;
  });

  return [allowed];
};

export default usePermission;
